;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('actionButtons', ActionButtonsDirective)

  ActionButtonsDirective.$inject = []

  function ActionButtonsDirective () {
    return {
      restrict: 'E',
      bindToController: true,
      controller: 'ProgressbarController',
      templateUrl: '/app/common/directives/action-buttons/action-buttons.html',
      controllerAs: 'action',
      scope: {
        readonly: '=',
        type: '=',
        obj: '=',
        availableStatus: '=',
        editable: '=',
        editMode: '=',
        theForm: '=',
        statusChange: '&',
        onSave: '&',
        asPdf: '&',
        asFacturX: '&',
        toChorus: '&',
        toPennylane: '&',
        asPdfWithInterventions: '&',
        asCsv: '&',
        asSpreadsheet: '&',
        duplicate: '&',
        asProforma: '&?',
        canEdit: '&?',
        canDisplay: '=',
        displaySaveButton: '&?',
        send: '&?',
        cancel: '&?'
      }
    }
  }
})(window.angular)
